<template>
    <div class="app">
        <div class="title">孺教网公众号</div>
        
    </div>
</template>
<script>
export default {
data() {
return {}
},
watch: {},
mounted() {},
methods: {}
}
</script>

<style lang="less" scoped>
    .app{
        background-color: #fff;
        min-height: 500px;
        padding: 30px 50px;
        .title{
            font-size: 18px;
            line-height: 30px;
            text-align: center;
            margin: 20px 0;
        }
    }
</style>